exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".EventView--in--3k9mOVT3 {\r\n  color: green;\r\n}\r\n\r\n.EventView--out--3nQRKQNU {\r\n  color: red;\r\n}\r\n", ""]);

// exports
exports.locals = {
	"in": "EventView--in--3k9mOVT3",
	"out": "EventView--out--3nQRKQNU"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"modules":true,"localIdentName":"[name]--[local]--[hash:base64:8]"}!./node_modules/postcss-loader/lib!./src/views/Beeper/Components/EventView.css
// module id = 959
// module chunks = 1